module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Yellow.334167b7.png";